(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["final-run"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('final-run')) {
    customElements.define('final-run', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.buttons = [...this.querySelectorAll('[data-filter]')];
        this.filterStrip = this.querySelector('.fr-filters');
        this.filterNav = this.querySelector('.fr-filter-nav');
        this.stateKey = `final-run:${location.pathname}:${this.id}`;
        this.state = { filter: 'all', variants: {}, quantities: {} };
        try { this.state = { ...this.state, ...JSON.parse(sessionStorage.getItem(this.stateKey) || '{}') }; } catch (_) {}
        this.cards.forEach(card => {
          card.variants = JSON.parse(card.querySelector('[data-variants]').textContent);
          card.initialPrices = [...card.querySelectorAll('[data-price]')].map(el => el.textContent);
          card.selection = this.initialSelection(card.variants, new URLSearchParams(location.search).get('variant'), this.state.variants[card.dataset.productId]);
          card.quantity = this.validQuantity(this.state.quantities?.[card.dataset.productId]) || 1;
          this.updateCard(card);
          const dialog = card.querySelector('dialog');
          if (dialog) {
            dialog.addEventListener('close', () => { card.opener?.setAttribute('aria-expanded', 'false'); if (!card.handoff && card.opener?.isConnected) card.opener.focus({ preventScroll: true }); card.handoff = false; }, { signal });
            dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, { signal });
            dialog.addEventListener('keydown', event => {
              if (event.key !== 'Tab') return;
              const focusable = [...dialog.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], summary, [tabindex="0"]')].filter(el => el.getClientRects().length > 0);
              const first = focusable[0], last = focusable[focusable.length - 1];
              if (event.shiftKey && (event.target === first || event.target === dialog)) { event.preventDefault(); last?.focus(); }
              else if (!event.shiftKey && event.target === last) { event.preventDefault(); first?.focus(); }
            }, { signal });
          }
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-filter')) this.filter(button.dataset.filter, true);
          if (button.hasAttribute('data-reset')) this.filter('all', true);
          const card = button.closest('[data-card]');
          if (!card) return;
          if (button.hasAttribute('data-open')) { card.handoff = false; card.opener = button; button.setAttribute('aria-expanded', 'true'); card.querySelector('dialog').showModal(); card.querySelector('[data-dialog-scroll]').scrollTop = 0; }
          if (button.hasAttribute('data-close')) card.querySelector('dialog').close();
          if (button.hasAttribute('data-continue')) {
            card.querySelectorAll('[data-success]').forEach(el => { el.hidden = true; });
            card.querySelectorAll('[data-feedback]').forEach(el => { el.textContent = ''; });
            const dialog = card.querySelector('dialog');
            if (dialog?.open) dialog.close();
          }
        }, { signal });
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-variant], [data-quantity]')) return;
          const card = event.target.closest('[data-card]');
          if (event.target.matches('[data-quantity]')) {
            card.quantity = this.validQuantity(event.target.value) || 1;
            this.state.quantities[card.dataset.productId] = card.quantity;
          } else {
            card.selection = event.target.value;
            if (!card.uncertain) { card.querySelectorAll('[data-feedback]').forEach(el => { el.textContent = ''; }); card.querySelectorAll('[data-success]').forEach(el => { el.hidden = true; }); }
            this.state.variants[card.dataset.productId] = card.selection;
            this.syncSelectionUrl(card);
          }
          this.updateCard(card);
          this.saveState();
        }, { signal });
        this.addEventListener('submit', event => {
          if (!event.target.matches('[data-cart-form]')) return;
          event.preventDefault();
          this.addToBag(event.target.closest('[data-card]'), event.submitter);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) this.filter('all', false);
        }, { signal });
        this.filterNav.hidden = false;
        this.refreshFilters();
        this.filterStrip.addEventListener('focusin', event => {
          const button = event.target.closest('[data-filter]');
          if (button) this.revealFilter(button);
        }, { signal });
        this.filterStrip.addEventListener('keydown', event => this.navigateFilters(event), { signal });
        this.filterStrip.addEventListener('scroll', () => this.updateFilterOverflow(), { signal, passive:true });
        this.filterObserver = new ResizeObserver(() => {
          const focused = this.buttons.find(button => button === document.activeElement && !button.hidden);
          this.revealFilter(focused || this.buttons.find(button => button.dataset.filter === this.state.filter));
        });
        this.filterObserver.observe(this.filterStrip);
        this.dataset.ready = '';
      }
      disconnectedCallback() {
        this.saveState();
        this.controller?.abort();
        this.filterObserver?.disconnect();
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      }
      saveState() { try { sessionStorage.setItem(this.stateKey, JSON.stringify(this.state)); } catch (_) {} }
      refreshFilters() {
        this.buttons.forEach(button => {
          const count = this.cards.filter(card => button.dataset.filter === 'all' || card.dataset.group === button.dataset.filter).length;
          button.querySelector('[data-count]').textContent = count;
          button.hidden = button.dataset.filter !== 'all' && count === 0;
        });
        this.filter(this.state.filter, false);
      }
      updateFilterOverflow() {
        const visible = this.buttons.filter(button => !button.hidden);
        const bounds = this.filterStrip.getBoundingClientRect();
        this.filterNav.dataset.moreStart = String(visible.some(button => button.getBoundingClientRect().left < bounds.left - 1));
        this.filterNav.dataset.moreEnd = String(visible.some(button => button.getBoundingClientRect().right > bounds.right + 1));
      }
      revealFilter(button) {
        if (!button || button.hidden) return;
        const bounds = this.filterStrip.getBoundingClientRect();
        const target = button.getBoundingClientRect();
        const delta = target.left < bounds.left + 28 ? target.left - bounds.left - 28 : target.right > bounds.right - 28 ? target.right - bounds.right + 28 : 0;
        if (delta) this.filterStrip.scrollBy({ left:delta, behavior:'instant' });
        this.updateFilterOverflow();
      }
      navigateFilters(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const visible = this.buttons.filter(button => !button.hidden);
        const index = visible.indexOf(event.target.closest('[data-filter]'));
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + visible.length) % visible.length;
        visible[next].focus({ preventScroll:true });
        this.revealFilter(visible[next]);
      }
      filter(group, announce) {
        if (!this.buttons.some(button => !button.hidden && button.dataset.filter === group)) group = 'all';
        this.state.filter = group;
        this.cards.forEach(card => { card.hidden = group !== 'all' && card.dataset.group !== group; });
        this.buttons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.filter === group)); });
        const count = this.cards.filter(card => !card.hidden).length;
        this.querySelector('[data-empty]').hidden = count > 0;
        this.querySelector('[data-reset]').hidden = this.cards.length === 0 || group === 'all';
        const selected = this.buttons.find(button => button.dataset.filter === group);
        if (announce) this.querySelector('[data-filter-status]').textContent = selected.textContent.trim();
        this.revealFilter(selected);
        this.saveState();
      }
      validQuantity(value) { const quantity = Number(value); return Number.isInteger(quantity) && quantity >= 1 && quantity <= 5 ? quantity : null; }
      syncSelectionUrl(card) {
        const selected = card.variants.find(variant => String(variant.id) === card.selection && variant.allowed && variant.available);
        const url = new URL(location.href);
        if (selected && card.variants.some(variant => String(variant.id) === url.searchParams.get('variant'))) {
          url.searchParams.set('variant', card.selection);
          history.replaceState(history.state, '', url.href);
        }
      }
      initialSelection(variants, requested, restored) {
        const available = variants.filter(variant => variant.allowed && variant.available);
        for (const preferred of [requested, restored]) {
          const match = available.find(variant => String(variant.id) === String(preferred));
          if (match) return String(match.id);
        }
        const direct = available.filter(variant => !variant.requiresPlan);
        const candidates = direct.length ? direct : available.length ? available : variants.filter(variant => variant.allowed && !variant.requiresPlan);
        if (candidates.length === 1) return String(candidates[0].id);
        const sizes = candidates.map(variant => ({ variant, ml: /^\s*\d+(?:\.\d+)?\s*ml\s*$/i.test(variant.size || '') ? Number(variant.size.replace(/ml/i, '').trim()) : null }));
        if (!sizes.length) return '';
        if (sizes.some(size => !size.ml)) return String(candidates[0].id);
        return String(sizes.reduce((smallest, size) => size.ml < smallest.ml ? size : smallest).variant.id);
      }
      async cartQuantity(variantId) {
        const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart read failed');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
        return cart.items.reduce((quantity, item) => {
          if (String(item.variant_id ?? item.id) !== String(variantId)) return quantity;
          if (!Number.isInteger(item.quantity) || item.quantity < 0) throw new Error('Invalid cart quantity');
          return quantity + item.quantity;
        }, 0);
      }
      updateCard(card) {
        const variant = card.variants.find(v => String(v.id) === card.selection);
        const canAdd = !!variant?.allowed && !!variant.available && !variant.requiresPlan;
        card.querySelectorAll('[data-variant]').forEach(select => { select.value = variant ? card.selection : ''; select.disabled = !!card.loading || !card.variants.some(option => option.allowed && option.available); });
        card.querySelectorAll('[data-quantity]').forEach(select => { select.value = String(card.quantity); select.hidden = !!variant?.requiresPlan; select.disabled = !!card.loading || !canAdd; });
        card.querySelectorAll('[data-price]').forEach((el, index) => { el.textContent = variant ? variant.price : card.initialPrices[index]; });
        card.querySelectorAll('[data-add]').forEach(button => {
          button.hidden = !!variant?.requiresPlan;
          button.disabled = !!card.loading || !!card.uncertain || !canAdd;
          button.textContent = card.loading ? this.dataset.labelAdding : !variant ? this.dataset.labelChoose : !variant.available ? this.dataset.labelSoldOut : !variant.allowed ? this.dataset.labelUnavailable : this.dataset.labelAdd;
        });
        const input = card.querySelector('[name="id"]');
        if (input) { input.value = variant ? String(variant.id) : ''; input.disabled = !canAdd; }
        card.querySelectorAll('[data-product-link], [data-plan-link]').forEach(link => {
          const url = new URL(link.href, location.origin);
          if (variant?.allowed) url.searchParams.set('variant', String(variant.id));
          else url.searchParams.delete('variant');
          link.href = url.href;
          if (link.hasAttribute('data-plan-link')) link.hidden = !variant?.requiresPlan;
        });
      }
      async addToBag(card, submitter) {
        const variant = card.variants.find(v => String(v.id) === card.selection);
        const quantity = this.validQuantity(card.quantity);
        if (this.cartPending || card.loading || card.uncertain || !quantity || !variant?.allowed || !variant.available || variant.requiresPlan) return;
        this.cartPending = true;
        card.loading = true;
        card.setAttribute('aria-busy', 'true');
        card.querySelectorAll('[data-success]').forEach(el => { el.hidden = true; });
        card.querySelectorAll('[data-feedback]').forEach(el => { el.textContent = ''; });
        this.updateCard(card);
        let rejected = false;
        let committed = false;
        let stockLimited = false;
        let drawerOpened = false;
        let beforeQuantity = null;
        let serverMessage = '';
        try {
          try { beforeQuantity = await this.cartQuantity(variant.id); } catch (_) {}
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity }] }) });
          rejected = !response.ok;
          stockLimited = response.status === 422;
          const result = await response.json();
          if (!response.ok) { serverMessage = typeof result.description === 'string' ? result.description : ''; throw new Error('Add rejected'); }
          committed = true;
          card.querySelectorAll('[data-feedback]').forEach(el => { el.textContent = this.dataset.labelAdded; });
          card.querySelectorAll('[data-success]').forEach(el => { el.hidden = false; });
          const drawer = window.theme?.cartDrawer;
          if (!drawer) throw new Error('Cart drawer unavailable');
          await drawer.cartForm.buildCart();
          if (!this.isConnected || !card.isConnected) return;
          // The shopper may have opened another scent while the add or rebuild was pending.
          const dialogs = [...document.querySelectorAll('final-run dialog[open]')];
          const activeDialog = dialogs.find(dialog => dialog.contains(document.activeElement)) || dialogs.at(-1);
          const activeCard = activeDialog?.closest('[data-card]');
          const returnFocus = [activeCard?.opener, submitter, card.opener].find(element => element?.isConnected && element.getClientRects().length > 0);
          if (!returnFocus) return;
          dialogs.forEach(dialog => {
            const owner = dialog.closest('[data-card]');
            if (owner) owner.handoff = true;
            dialog.close();
          });
          // The live ATOZ drawer can open on cart/add.js before this add completes.
          // Keep the Final Run trigger as its native close-focus target in that case.
          returnFocus.setAttribute('aria-expanded', 'true');
          if (drawer.drawer) drawer.drawer.activeSource = returnFocus;
          drawer.open(returnFocus);
          drawerOpened = true;
        } catch (error) {
          card.uncertain = !committed && (!rejected || stockLimited);
          let message = committed ? this.dataset.labelDrawerError : stockLimited ? (serverMessage || this.dataset.labelStockLimit) : rejected ? (serverMessage || this.dataset.labelError) : this.dataset.labelUncertain;
          if (stockLimited) {
            let reconciliation = this.dataset.labelStockRefresh;
            try {
              const total = await this.cartQuantity(variant.id);
              const template = beforeQuantity === null ? this.dataset.labelStockTotal : this.dataset.labelStockCount;
              reconciliation = template.replaceAll('{total}', String(total)).replaceAll('{before}', String(beforeQuantity));
            } catch (_) {}
            message = `${message} ${reconciliation}`;
          }
          card.querySelectorAll('[data-feedback]').forEach(el => { el.textContent = message; });
          if (committed || card.uncertain) card.querySelectorAll('[data-success]').forEach(el => { el.hidden = false; });
          if (card.uncertain) { try { await window.theme?.cartDrawer?.cartForm.buildCart(); } catch (_) {} }
        } finally {
          this.cartPending = false;
          card.loading = false;
          card.removeAttribute('aria-busy');
          this.updateCard(card);
          if (!drawerOpened && card.isConnected && (document.activeElement === document.body || document.activeElement === submitter)) {
            const scope = card.querySelector('dialog[open]') || card.querySelector('.fr-card-body');
            scope.querySelector('[data-feedback]').focus({ preventScroll: true });
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
